import DRAW_HISTORY from '@/setting/layout/pre-origination/detail/draw-history'
import LOAN_DETAILS from '@/setting/layout/pre-origination/detail/loan-details'
import LOAN_HISTORY from '@/setting/layout/pre-origination/detail/loan-history'
import { PAYMENT_SCHEDULE, PAYMENT_AMOUNT } from '@/setting/layout/pre-origination/detail/payment-schedule'
export const LOS_DETAIL_LAYOUT_SETTING = {
  DRAW_HISTORY,
  LOAN_DETAILS,
  LOAN_HISTORY,
  PAYMENT_SCHEDULE,
  PAYMENT_AMOUNT
}
